import React, { useEffect, useState } from "react"
import { withRouter, Link } from "react-router-dom"

import MetaTags from "react-meta-tags"

import { Container } from "reactstrap"
import Breadcrumbs from "components/Common/Breadcrumb"
import Table from "./Table"
import { useSelector, useDispatch } from "react-redux"
import { getAllCampaigns } from "./../../../../store/Campaigns/actions"
import { getCampaigns } from "helpers/repository"
import { sitename } from "../../../../constants/constants"

const Campaigns = props => {
  const dispatch = useDispatch()
  const [data, setData] = useState([])
  const [totalData, setTotalData] = useState(0)
  const [loadingMessage, setLoadingMessage] = useState("1")

  // useEffect(() => {
  //   console.log("hello");
  //   dispatch(getAllCampaigns())
  // }, [])

  // const data = useSelector(state => state.campaigns.Index ?? [])
  useEffect(() => {
    setLoadingMessage("1")
    getCampaigns(getCampaignsSuccess, getCampaignsError)
    // dispatch(getAllSports())
  }, [])

  const getCampaignsSuccess = res => {
    setData(res?.data?.data ?? [])
    setTotalData(res.data.total)
    setLoadingMessage("0")
  }
  const getCampaignsError = error => {}
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Admin" breadcrumbItem="Campaigns" />
        </Container>
        <Table
          data={data}
          getCampaigns={() => {
            getCampaigns(getCampaignsSuccess, getCampaignsError)
          }}
          count={totalData}
          loadingMessage={loadingMessage}
          setLoadingMessage={setLoadingMessage}
        />
      </div>
    </React.Fragment>
  )
}

export default withRouter(Campaigns)
